var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__wrapper"},[_c('order-message',{staticClass:"message"},[_c('img',{attrs:{"slot":"icon","src":_vm.icon},slot:"icon"}),_c('span',{attrs:{"slot":"text"},slot:"text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{attrs:{"slot":"additional-text"},slot:"additional-text"},[_vm._v(_vm._s(_vm.additionalText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }